import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import { loadPageData } from 'redux/actions/Request'

import { 
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress
} from '@material-ui/core'

import FlagIcon from '@material-ui/icons/Flag'
import ErrorIcon from '@material-ui/icons/Error'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CompareArrowsIcon from '@material-ui/icons/CompareArrows'

import FindingCard from 'views/Components/Finding/Card'
import RunTestDialog from 'views/Components/RunTestDialog'
import VisualizationList from 'views/Components/VisualizationList'
import { popularReports } from '../PopularReports/popularReportsList'
import FunnelVisualization from 'views/Components/FunnelVisualization'
import SearchableListDialog from 'views/Components/SearchableListDialog'
import { isMicrosoft, isGlobal } from 'views/Components/Reporting/helpers'
import MoreDetectionCoverageDialog from 'views/Components/MoreDetectionCoverageDialog'

import { INTEGRATION_STATUS } from '../CloudModules/constants'
import Request from 'lib/api/Request';

import { DemoAPI } from '../../../lib/api'

const moment = require('moment-timezone');

const API = { demo: new DemoAPI() }

const O365_CONNECTOR = 'o365/Initialize'

const useStyles = makeStyles((theme) => ({
    page: {
        padding: `0 ${theme.shape.padding}px`
    },
    row: {
        display: 'flex'
    },
    topRowContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.shape.padding
    },
    sortedDataContainer: {
        flexDirection: 'column'
    },
    sortedDataText: {
        margin: 0,
        color: theme.palette.grey[400]
    },
    baseContainer: {
        minHeight: 120,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper
    },
    findingNumberText: {
        fontSize: 22,
        marginBottom: 0,
        fontWeight: 'bold'
    },
    dataTitle: {
        fontSize: 12,
        fontWeight: 500,
        marginBottom: 0
    },
    dataText: {
        fontSize: 35,
        fontWeight: 400,
        marginBottom: 0
    },
    rulesContainer: {
        width: '10%',
        display: 'flex',
        cursor: 'pointer',
        flexDirection: 'column',
        padding: theme.shape.padding,
        justifyContent: 'space-between',
        marginRight: theme.shape.padding
    },
    connectorStatusContainer: {
        width: '30%',
        padding: theme.shape.padding,
        marginRight: theme.shape.padding
    },
    status: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: theme.shape.padding,
        '& p': {
            marginBottom: 5
        }
    },
    statusIcon: {
        marginRight: 10,
    },
    success: {
        color: theme.palette.success.main
    },
    error: {
        color: theme.palette.error.main
    },
    testRunContainer: {
        width: '20%',
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        '& p': {
            marginBottom: 0
        }
    },
    reportNumberContainer: {
        height: 100,
        width: '10%',
        display: 'flex',
        cursor: 'pointer',
        flexDirection: 'column',
        padding: theme.shape.padding,
        justifyContent: 'space-between',
        marginRight: theme.shape.padding
    },
    popReportPlaceholder: {
        width: '90%',
        height: 100,
        padding: theme.shape.padding
    },
    emptyStateContainer: {
        height: 200,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper
    },
    dialogHeaderContainer: {
        display: 'flex',
        paddingRight: 30,
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    dialogContent: {
        padding: theme.shape.padding * 2
    },
    close: {
        cursor: 'pointer'
    },
    sectionTitle: {
        marginBottom: 0
    },
    list: {
        paddingLeft: theme.shape.padding,
    },
    listItem: {
        marginLeft: theme.shape.padding
    },
    dialogActions: {
        justifyContent: 'flex-start',
        padding: theme.shape.padding * 2,
        paddingTop: 0
    },
    red: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.error.main
    }
}))

const SummaryDashboard = props => {
    const classes = useStyles()

    const [connector, setConnector] = useState(false)
    const [visibleReports, setVisibleReports] = useState([])
    const [loadingFindings, setLoadingFindings] = useState(false)
    const [visibleSavedQueries, setVisibleSavedQueries] = useState([])
    const [isReportsDialogOpen, setIsReportsDialogOpen] = useState(false)
    const [isRunTestDialogOpen, setIsRunTestDialogOpen] = useState(false)
    const [visibleFindings, setVisibleFindings] = useState(props.findings)
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false)
    const [isDetectionRulesDialogOpen, setIsDetectionRulesDialogOpen] = useState(false)
    const [isDetectionCoverageDialogOpen, setIsDetectionCoverageDialogOpen] = useState(false)

    useEffect(() => {
        if(props.savedQueries){
            let newVisibleSavedQueries = filterReports(props.savedQueries)
            setVisibleSavedQueries(newVisibleSavedQueries)
        }
    }, [props.savedQueries]) /* eslint-disable-line */

    useEffect(() => {
        setVisibleFindings(props.findings)
    }, [props.findings])

    useEffect(() => {
        if(props.integrations){
            const o365Connector = props.integrations.find(({ integrationType }) => integrationType === O365_CONNECTOR)
            setConnector(o365Connector)
        }
    }, [props.integrations])

    useEffect(() => {
        if(props.savedQueries && props.savedQueries.length){
            let report = popularReports.find(pr => pr.id === 1050)
            report.model = props.savedQueries.find(sq => sq.id === report.id)
            if(report.model){
                report.request = new Request('/bq')
                report.request.fromQuery(report.model)
                report.request.setResultParam('outputFields', [report.field])
                report.request.setResultParam('transform', [{operator:'count', value:'grouped_count'}])
                report.request.setResultParam('orderBy', [{key:'grouped_count', value: -1}])
                // clear any queryParams already dealing with date
                Object.keys(report.request.queryParams).forEach(uuid=>{
                  if(report.request.queryParams[uuid].field==='created'){
                    report.request.deleteQueryParam(uuid)
                  }
                })

                report.request.setQueryParam({
                  field:'created',
                  operator: 'gt',
                  value: moment().add(-6, 'months').format("YYYY-MM-DDTHH:mm")
                })

                report.request.setQueryParam({
                  field:'created',
                  operator: 'lt',
                  value: moment().format("YYYY-MM-DDTHH:mm")
                })

                report.request.get().then(results=>{
                    const formattedResults = report.formatFunction(results)
                    report.data = formattedResults
                    setVisibleReports([report])
                })

            }
        }
    }, [props.savedQueries])


    const filterReports = (queries) => {
        if(props.license.isTagged('limited-to-microsoft')){
          return queries.filter(o=>isGlobal(o)).filter(o=>isMicrosoft(o))
        }
        return queries
    }

    const toggleReportsDialog = () => {
        setIsReportsDialogOpen(!isReportsDialogOpen)
    }

    const toggleDetectionRulesDialog = () => {
        setIsDetectionRulesDialogOpen(!isDetectionRulesDialogOpen)
    }

    const toggleDetectionCoverageDialog = () => {
        setIsDetectionCoverageDialogOpen(!isDetectionCoverageDialogOpen)
    }

    const toggleRunTestDialog = () => {
        setIsRunTestDialogOpen(!isRunTestDialogOpen)
    }

    const toggleConfirmationModal = () => {
        setIsConfirmationDialogOpen(!isConfirmationDialogOpen)
    }

    const handleGetMoreClick = () => {
        setIsDetectionRulesDialogOpen(false)
        setIsDetectionCoverageDialogOpen(true)
    }

    const handleReportItemClick = (reportId) => {
        if(reportId)
            props.routeToSavedReport(reportId, props.orgId)
    }

    const handleGenerateData = async () => {
        const data = {
            org_id: props.orgId,
            launch: true,
            reset: true,
        }

        setLoadingFindings(true)
        toggleConfirmationModal()
        
        await API.demo.resetDemo({ 
            orgId: props.orgId, data 
        })

        // account for generation time
        setTimeout(() => {
            setLoadingFindings(false)
            props.reload(true)
        }, 3500)
    }

    const canGenerateFindings = () => {
        // page is loaded with data, no findings, and license is defined and free
        return !!props.ready && !visibleFindings.length && props?.license?.isTagged('limited-to-free')
    }

    const integrationStatus = () => {
        if (connector.integrationStatus === INTEGRATION_STATUS.INIT) {
            return (
                <div className={classes.row}>
                    <CircularProgress size={20} className={classes.statusIcon} />
                    <p>Initializing…</p>
                </div>
            )
        } else if (connector.integrationStatus === INTEGRATION_STATUS.OK) {
            return (
                <div className={classes.row}>
                    <CheckCircleIcon className={`${classes.statusIcon} ${classes.success}`} />
                    <p>Connected</p>
                </div>
            )
        } else if (connector.integrationStatus === INTEGRATION_STATUS.ERROR) {
            return (
                <div className={classes.row}>
                    <ErrorIcon className={`${classes.statusIcon} ${classes.error}`} />
                    <p>Error</p>
                </div>
            )
        } else {
            return <div className={classes.row}>{connector.integrationStatus}</div>
        }
    }

    return (
        <div className={classes.page}>
            <div className={classes.topRowContainer}>
                <FunnelVisualization
                    ready={props.ready}
                    findings={visibleFindings.length || 0}
                    logsTotal={props.logsTotal && props.logsTotal.length > 0 ? props.logsTotal[0].grouped_count : 0}
                    blockedEvents={props.blockedEvents && props.blockedEvents.length > 0 ? props.blockedEvents[0].grouped_count : 0}
                    threats={props.threats && props.threats.length > 0 ? props.threats[0].count : 0}
                    suspects={props.suspects && props.suspects.length > 0 ? props.suspects[0].count : 0}
                />
                <div className={`${classes.baseContainer} ${classes.rulesContainer}`} onClick={toggleDetectionRulesDialog}>
                    <p className={classes.dataTitle}>Detection rules</p>
                    <p className={classes.dataText}>{props?.rules?.length ? props.rules.length : 0}</p>
                </div>
                <div className={`${classes.baseContainer} ${classes.connectorStatusContainer}`}>
                    {connector ? 
                        <p className={classes.dataTitle}>{connector ? connector.integrationName : 'Microsoft 365 Cloud Connector Status'}</p>
                    :
                    (props.ready && !connector) ?
                        <p className={classes.dataTitle}>No Cloud Connector detected</p>
                    :
                        <p className={classes.dataTitle}>Gathering Cloud Connector data...</p>
                    }
                    {connector &&
                        <div className={classes.status}>
                            {integrationStatus()}
                            <div className={classes.row}>
                                <CompareArrowsIcon className={classes.statusIcon} />
                                <p>Last log event detected: {moment.utc(connector.lastStausUpdate).tz(moment.tz.guess(true)).fromNow()}</p>
                            </div>
                        </div>
                    }
                    {(!connector && !props.ready) &&
                        <div className={classes.status}>
                            <CircularProgress />
                        </div>
                    }
                </div>
                <div className={`${classes.baseContainer} ${classes.testRunContainer}`} onClick={toggleRunTestDialog}>
                    <FlagIcon />
                    <p>Run a test</p>
                </div>
            </div>
            <div className={classes.topRowContainer}>
                <div className={`${classes.baseContainer} ${classes.reportNumberContainer}`} onClick={toggleReportsDialog}>
                    <p className={classes.dataTitle}>Reports</p>
                    <p className={classes.dataText}>{visibleSavedQueries.length ? visibleSavedQueries.length : 0}</p>
                </div>
                {(props.ready && visibleReports.length) ?
                    <VisualizationList theme={props.theme} listData={visibleReports} isLoading={!props.ready} standAlone={true} />
                :
                    <div className={`${classes.baseContainer} ${classes.popReportPlaceholder}`}>
                        {!props.ready ?
                            <p>Loading your report overview...</p>
                        :
                            <p>Nothing to report, yet...</p>
                        }
                        {!props.ready && <CircularProgress size={30} />}
                    </div>
                }
            </div>
            <div className={classes.topRowContainer}>
                <div className={classes.sortedDataContainer}>
                    <p className={classes.findingNumberText}>
                        {!!visibleFindings.length ? `${visibleFindings.length} Unresolved Findings` : 'No Unresolved Findings'}
                    </p>
                    {!!visibleFindings.length && <p className={classes.sortedDataText}>Past 6 months, sorted by newest first</p>}
                </div>
                {canGenerateFindings() && 
                    <Button variant={'contained'} className={classes.red} onClick={toggleConfirmationModal} disabled={!!loadingFindings} datacy={'generateSampleFindingsBtn'}>
                        {!!loadingFindings ? 'Generating sample findings' : 'Generate sample findings'}
                    </Button>
                }
            </div>
            {(!props.ready || !!loadingFindings) ?
                <div>
                    <div className={classes.emptyStateContainer}>
                        <p>Loading your unresolved findings...</p>
                        <CircularProgress />
                    </div>
                </div>
            : !!visibleFindings.length ? visibleFindings.map(finding => (
                <FindingCard
                    {...finding}
                    key={finding.id}
                    hideComments={true}
                    constants={props.constants}
                />
            )) :
            <div className={classes.emptyStateContainer}>
                <p>No unresolved findings were generated.</p>
            </div>
            }
            <SearchableListDialog 
                title={'Reports'}
                items={visibleSavedQueries}
                open={isReportsDialogOpen}
                onClose={toggleReportsDialog}
                onItemClick={handleReportItemClick}
            />
            <SearchableListDialog 
                items={props.rules}
                title={'Detection rules'}
                open={isDetectionRulesDialogOpen}
                onClose={toggleDetectionRulesDialog}
                handleGetMoreClick={handleGetMoreClick}
                emptyText={'Detection rules will appear as soon as Blumira processes your incoming log data. This can take up to 60 minutes after you set up your first Cloud Connector or Sensor.'}
            />
            <MoreDetectionCoverageDialog 
                open={isDetectionCoverageDialogOpen}
                onClose={toggleDetectionCoverageDialog}
            />
            <RunTestDialog 
                open={isRunTestDialogOpen}
                onClose={toggleRunTestDialog}
            />
            <Dialog open={isConfirmationDialogOpen}>
                <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
                <DialogContent>
                    <strong>WARNING:</strong>
                    <p>Generating new findings will take a few moments and add example data to your account so that you can learn what Blumira findings look like and how to respond to them.</p>
                    <p>The activity in these sample findings is not real and is not based on data your organization sent to Blumira.</p>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button onClick={handleGenerateData} className={classes.red} variant={'contained'}>
                        Confirm
                    </Button>
                    <Button onClick={toggleConfirmationModal} color="primary" variant={'outlined'}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

SummaryDashboard.defaultProps = { 
    findings: []
}

const mapStateToProps = state => ({
    license: state.license,
    orgId: state.location.payload.orgId
})

const mapDispatchToProps = dispatch => {
    return {
        routeToSavedReport: (reportId, orgId) => {
            dispatch({ 
                type: 'PAGE',
                payload: { 
                    orgId: orgId, 
                    id1: reportId,
                    toplevel: 'reporting', 
                    secondlevel: 'builder', 
                } 
            })
        },
        reload: (force)=>dispatch(loadPageData(force))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryDashboard)
